import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import projectMarks from "./projectMarks";


export default function ProjectRail({ projects }) {
  const scroller = useRef(null);
  const [edges, setEdges] = useState({ prev: false, next: false });

  useEffect(() => {
    const el = scroller.current;
    if (!el) return undefined;

    const update = () => {
      setEdges({
        prev: el.scrollLeft > 4,
        next: el.scrollLeft + el.clientWidth < el.scrollWidth - 4,
      });
    };

    update();
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [projects]);

  const scroll = (direction) => {
    const el = scroller.current;
    if (!el) return;
    const card = el.querySelector("[data-project-card]");
    const amount = card ? card.getBoundingClientRect().width + 16 : el.clientWidth * 0.85;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    el.scrollBy({ left: direction * amount, behavior: reduce ? "auto" : "smooth" });
  };

  const showArrows = edges.prev || edges.next;

  return (
    <div className="min-w-0 max-w-full">
      {showArrows ? (
        <div className="mb-3 flex justify-end gap-2">
          <button
            type="button"
            className="rail-btn"
            aria-label="Previous project"
            onClick={() => scroll(-1)}
            disabled={!edges.prev}
          >
            <span aria-hidden="true">‹</span>
          </button>
          <button
            type="button"
            className="rail-btn"
            aria-label="Next project"
            onClick={() => scroll(1)}
            disabled={!edges.next}
          >
            <span aria-hidden="true">›</span>
          </button>
        </div>
      ) : null}
      <div ref={scroller} className="project-rail">
        {projects.map((project) => (
          <Link
            key={project.title}
            to={project.href}
            data-project-card
            className="project-card"
          >
            <span className="project-card-copy">
              <span className="flex items-start justify-between gap-4">
                <span className="text-xl font-medium tracking-tight text-[var(--ink)]">{project.title}</span>
                {project.marks?.length ? (
                  <span className="flex shrink-0 gap-2 text-[var(--accent)]">
                    {project.marks.map((name) => {
                      const Icon = projectMarks[name];
                      return Icon ? <Icon key={name} aria-hidden="true" size={22} /> : null;
                    })}
                  </span>
                ) : null}
              </span>
              <span className="mt-3 block text-sm leading-relaxed text-[var(--muted)]">{project.description}</span>
              <span className="mt-4 flex flex-wrap gap-2">
                {project.tags.map((tag) => (
                  <span key={tag} className="pill">
                    {tag}
                  </span>
                ))}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
